import { Cable, CableTermType, EngineeringStatus, MetadataTableName } from '@bechtel/sr-types';

export interface IssueComponentsFormikState {
  commodityType: string;
  engineeringStatus: Cable['engineeringStatus'];
  whereClause: string;
  term: CableTermType;
  note: string;
}

export const issueComponentsInitialValues: IssueComponentsFormikState = {
  commodityType: MetadataTableName.CABLE,
  engineeringStatus: EngineeringStatus.UNPREPARED,
  whereClause: '',
  term: CableTermType.F,
  note: '',
};
